export const C_PREDICTIONS_PER_PAGE_COUNT = 10;
